import { render, staticRenderFns } from "./BannerTaiShi.vue?vue&type=template&id=36e26678&scoped=true"
import script from "./BannerTaiShi.vue?vue&type=script&lang=js"
export * from "./BannerTaiShi.vue?vue&type=script&lang=js"
import style0 from "./BannerTaiShi.vue?vue&type=style&index=0&id=36e26678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e26678",
  null
  
)

export default component.exports